<template>
  <wallet-form-shell>
    <div v-if="error">
      <wallet-form-header
        :title="errorTitle"
        :message="errorMessage"
      />
      <v-btn
        block
        color="primary"
        large
        outlined
        class="text-capitalize mt-10"
        :to="forgotPasswordRoute"
      >
        {{ errorButtonText }}
      </v-btn>
    </div>
    <div v-else-if="submitted">
      <wallet-form-header
        :title="title"
        :message="message"
      />
      <v-btn
        block
        color="primary"
        large
        outlined
        class="text-capitalize mt-10"
        :to="loginRoute"
      >
        {{ loginText }}
      </v-btn>
    </div>
    <div v-else-if="tokenChecked">
      <wallet-form
        :form-type="formType"
        :loading="submitting"
        @form-submit="reset"
      />
    </div>
  </wallet-form-shell>
</template>

<script>
import WalletFormShell from '@/components/wallet/WalletFormShell'
import WalletForm from '@/components/wallet/WalletForm'
import WalletFormHeader from '@/components/wallet/WalletFormHeader'
import { WalletFormType } from '@/components/wallet/wallet-form-type'
import {
  WALLET_LOGIN_ROUTE,
  WALLET_FORGOT_ROUTE
} from '@/router/routes/route-names'
import { WalletApi } from '@/cowboy/wallet/WalletApi'

export default {
  name: 'ResetPassword',
  components: {
    WalletFormShell,
    WalletForm,
    WalletFormHeader
  },
  data () {
    return {
      error: false,
      submitting: false,
      submitted: false,
      tokenChecked: false
    }
  },
  computed: {
    errorButtonText () {
      return this.$t('wallet.reset.error.buttonText')
    },
    errorMessage () {
      return this.$t('wallet.reset.error.message')
    },
    errorTitle () {
      return this.$t('wallet.reset.error.title')
    },
    forgotPasswordRoute () {
      return { name: WALLET_FORGOT_ROUTE }
    },
    formType () {
      return WalletFormType.PASSWORD_RESET
    },
    loginRoute () {
      return { name: WALLET_LOGIN_ROUTE }
    },
    loginText () {
      return this.$t('wallet.login.title')
    },
    title () {
      return this.$t('wallet.reset.title-submitted')
    },
    token () {
      const { token } = this.$route.query || {}
      return token
    },
    message () {
      return this.$t('wallet.reset.message-submitted')
    }
  },
  async mounted () {
    await this.convertTokenToJwtIfNeeded()
  },
  methods: {
    async convertTokenToJwtIfNeeded () {
      try {
        if (this.token) {
          await WalletApi.forgotPasswordTokenToJwt(this.token)
        }
      } catch (error) {
        this.error = true
      } finally {
        this.tokenChecked = true
      }
    },
    async reset ({ password, confirmPassword }) {
      this.submitting = true
      try {
        await WalletApi.resetPassword(password, confirmPassword)
        this.submitted = true
      } catch (e) {
        console.error(e)
        this.error = true
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
